module.exports = __webpack_public_path__ + "img/bank-1.3320ed4c.jpg";